exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".trigger-item-span{display:inline-block;width:154px;position:absolute;left:-28px;padding-left:28px;right:-16px;padding-right:16px;height:30px;line-height:30px;top:-22px}", ""]);

